
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M23.706 8.482a1.505 1.505 0 00-1.406-.98h-6.087a.5.5 0 01-.472-.334L13.556.975a1.5 1.5 0 00-2.81 0l-.005.016-2.18 6.177a.5.5 0 01-.47.334H2a1.5 1.5 0 00-.963 2.65l5.184 4.3a.5.5 0 01.155.544L4.2 21.526a1.5 1.5 0 002.31 1.685l5.346-3.92a.5.5 0 01.591 0l5.344 3.919a1.5 1.5 0 002.312-1.683l-2.178-6.535a.5.5 0 01.155-.543l5.194-4.306a1.5 1.5 0 00.433-1.661z"}})])
          )
        }
      }
    